import MarkPurchasedModal from './mark-purchased-modal'

export default MarkPurchasedModal
